import { useNavigate, useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { onboardingPath } from "../../core/primitives/onboarding";
import { OnboardingShopController } from "./onboarding-shop-controller";
import { OnboardingShopPage } from "./onboarding-shop-page";

export function OnboardingShopRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const claimReview = searchParams.get("claimReview") === "1";
  return (
    <Subtree
      key="onboarding-shop"
      deps={[claimReview]}
      controller={() =>
        new OnboardingShopController(
          pick(deps, "client", "authHandler", "storeRepository"),
          { claimReview },
          {
            toNext: (storeId, claim) =>
              navigate(claim ? onboardingPath("locations", storeId, true) : onboardingPath("selling", storeId)),
          },
        )
      }
    >
      <OnboardingShopPage />
    </Subtree>
  );
}
